// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"C2-z"};